export default "__VITE_ASSET__5F81BuF$__"